import React from "react";

interface MobileMenuToggleButtonProps {
  icon: string;
  handleClick: () => void;
}

export const MobileMenuToggleButton: React.FC<MobileMenuToggleButtonProps> = ({
  icon,
  handleClick,
}) => {
  return (
    <button
      className="mobile-nav-bar__toggle"
      id="mobile-menu-toggle-button"
      onClick={handleClick}
    >
      {icon === 'menu' ? '☰' : '✕'}
    </button>
  );
};
